import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { MuiThemeProvider } from '@material-ui/core/styles';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';

import theme from 'theme/index';
import AuthProvider from './Auth';
import GraphqlProvider from './Graphql';

interface Props {
  children: React.ReactNode;
}

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY || '');

const Providers: React.SFC<Props> = ({ children }: Props) => (
  <AuthProvider>
    <GraphqlProvider>
      <BrowserRouter>
        <Elements stripe={stripePromise}>
          <MuiThemeProvider theme={theme}>{children}</MuiThemeProvider>
        </Elements>
      </BrowserRouter>
    </GraphqlProvider>
  </AuthProvider>
);

export default Providers;
